module.exports = __webpack_public_path__ + "img/Refresh2.5ab45043.svg";